export default __webpack_public_path__ + "static/scientist9-52b76f2e252fd7d83c259d10deac7a10.jpg";